module.exports = __webpack_public_path__ + "img/834000340_4.b4037d5f.jpg";